<template>
  <ForgotPasswordForm
    :show-right-panel="true"
    :show-logo-link="true"
    :show-language-selector="true"
    :show-background-images="true"
    :show-recaptcha="true"
    :enable-redirect="true"
    @forgot-password-success="handleForgotPasswordSuccess"
    @forgot-password-error="handleForgotPasswordError"
    @goto-login="handleGotoLogin"
    @goto-signup="handleGotoSignup"
    @email-sent="handleEmailSent"
  />
</template>

<script setup>
import ForgotPasswordForm from "../components/ForgotPasswordForm.vue";

// Event handlers for ForgotPasswordForm
function handleForgotPasswordSuccess(email) {
  // Forgot password success is handled by ForgotPasswordForm's internal logic
  console.log("Forgot password email sent to:", email);
}

function handleForgotPasswordError(error) {
  // Error handling is managed by ForgotPasswordForm
  console.log("Forgot password error:", error);
}

function handleGotoLogin() {
  // Login navigation is handled by ForgotPasswordForm's internal redirect logic
  console.log("Navigating to login");
}

function handleGotoSignup() {
  // Signup navigation is handled by ForgotPasswordForm's internal redirect logic
  console.log("Navigating to signup");
}

function handleEmailSent(email) {
  // Email sent confirmation
  console.log("Password reset email sent to:", email);
}
</script>
